import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';


const override = {
  baseUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com',
  hostname: 'pioneer-ci2.dev.onyxcentersource.com',

  googleAnalytics: {
    id: 'UA-96125697-1',
    loadType: 'auto'
  }
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.ci2.ts